<script setup lang="ts">
definePageMeta({
  title: 'Our Services',
  label: 'Services',
  order: 1,
  middleware: (to) => {
    const { path, matched } = to
    if (/\/services\/?$/.test(path)) {
      return navigateTo(['/services', matched[0]?.children[0]?.path].join('/'), {
        redirectCode: 301,
      })
    }
  },
})
</script>

<template>
  <PageRoot>
    <PageHead
      :at-root="false"
      bg-class="bg-white"
    >
      <div class="absolute-inset from-white/60 to-white/80 bg-linear-to-b size-full dark:from-icsnight-950/60 dark:to-icsnight-950/80" />
      <template #parallax>
        <NuxtImg
          src="50c123ce-9a81-46bf-8bdf-5468cd672d92"
          class="ml-auto mr-0 transition-max-width absolute-inset object-cover object-top brightness-120 size-full lg:max-w-screen-lg md:max-w-screen-md"
          alt="A close-up photograph of a cable assembly built by ICS, predominantly featuring a LEMO connector. The other end of the cable recedes into the background, out of focus."
        />
      </template>
    </PageHead>
    <PageBody>
      <NuxtPage />
    </PageBody>
  </PageRoot>
</template>
